<div class="modal-header justify-content-start align-items-center py-0">
    <i class="mdi mdi-alert-circle-outline text-warning f-60 py-2 pr-2"></i>
    <h1 class="fw-500">Sua senha está expirada.</h1>
  </div>
  <div class="modal-body p-4">
  
    <div class="f-20 text-uppercase">
      <div class="py-1" *ngIf="formValues?.documento">Deseja redefiní-la?</div>
    </div>
  
  </div>
  <div class="modal-footer d-flex">
    <button type="button" class="btn mr-2 btn-secondary" (click)="activeModal.close('cancel')">Cancelar</button>
    <button type="button" ngbAutofocus class="w-100 btn btn-success" (click)="activeModal.close('ok')">Redefinir senha</button>
  </div>
  